import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import Card from "components/card/Card";
import { Link } from "react-router-dom";
import { PageCollapseWidth } from "../../constants";
import GoogleAd from "components/googleAd/GoogleAd";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | ToolWeaver</title>
        <meta
          name="description"
          content="Read the ToolWeaver privacy policy and learn how we protect your data and ensure your information remains secure."
        />
        <link rel="canonical" href="https://toolweaver.com/privacypolicy" />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="Privacy Policy">
          <span className="d-block mb-4">
            Welcome to ToolWeaver! Your privacy is important to us. This Privacy
            Policy outlines how we handle any information collected through our
            website. By using ToolWeaver, you agree to the terms outlined in
            this policy.
          </span>
          <ol>
            <li>
              Acceptance of Terms
              <span className="mt-3 mb-3 d-block">
                By accessing ToolWeaver, you acknowledge that you have read,
                understood, and agree to be bound by these terms and conditions.
                We reserve the right to modify these terms at any time, and such
                modifications shall be effective immediately upon posting on the
                website. Your continued use of the site constitutes your
                acceptance of the modified terms.
              </span>
            </li>
            <li>
              Information We Do Not Collect
              <span className="mt-3 mb-3 d-block">
                ToolWeaver does not collect any personal information from its
                users. We do not require you to create an account, provide
                personal details, or submit any personal data to access the
                tools available on our site.
              </span>
              <span className="d-block mb-3">
                We do not intentionally store your submitted content. Standard
                server logs may record limited metadata (e.g., IP address,
                request timing) for security and reliability.
              </span>
            </li>
            <li>
              Privacy Policy
              <span className="mt-3 mb-3 d-block">
                ToolWeaver does not collect any personal information from its
                users. However, we use Google Ads and Google Analytics, which
                may create tracking cookies for advertising and analytical
                purposes. By using our site, you consent to the use of cookies
                in accordance with our Privacy Policy. You can manage your
                cookie preferences through your browser settings.
              </span>
            </li>
            <li>
              Cookies and Tracking Technologies
              <span className="mt-3 mb-3 d-block">
                You can manage your cookie preferences through your browser
                settings. Most browsers allow you to refuse cookies or alert you
                when cookies are being sent. Please note that disabling cookies
                may affect the functionality of our website.
              </span>
              <span className="d-block mt-2">
                <strong className="me-2 d-inline-block">Google Ads:</strong>
                We use Google Ads to display advertisements on our site. Google
                may use cookies to serve ads based on your prior visits to our
                website or other websites. You can opt out of personalized
                advertising by visiting Google Ads Settings.
              </span>
              <span className="d-block mt-2 mb-3">
                <strong className="me-2 d-inline-block">
                  Google Analytics:
                </strong>
                We use Google Analytics to help us understand how users interact
                with our site. Google Analytics collects information such as
                your IP address, browser type, and pages visited. This
                information is used to analyze site traffic and improve our
                services. You can opt out of Google Analytics by installing the
                Google Analytics Opt-out Browser Add-on.
              </span>
            </li>
            <li>
              Managing Cookies
              <span className="mt-3 mb-3 d-block">
                All content, trademarks, and data on ToolWeaver, including but
                not limited to text, graphics, logos, and software, are the
                property of ToolWeaver or its content suppliers and are
                protected by applicable intellectual property laws. You may not
                reproduce, distribute, or create derivative works from any
                content on the site without express written permission from
                ToolWeaver.
              </span>
            </li>
            <li>
              Third-Party Links
              <span className="mt-3 mb-3 d-block">
                ToolWeaver may contain links to third-party websites. We are not
                responsible for the privacy practices or content of these
                external sites. We encourage you to review the privacy policies
                of any third-party sites you visit.
              </span>
            </li>
            <li>
              Third-Party Links
              <span className="mt-3 mb-3 d-block">
                ToolWeaver may contain links to third-party websites. These
                links are provided for your convenience only, and ToolWeaver
                does not endorse or assume any responsibility for the content or
                practices of these third-party sites. Accessing these sites is
                at your own risk.
              </span>
            </li>
            <li>
              Data Security
              <span className="mt-3 mb-3 d-block">
                While we do not collect personal information, we are committed
                to ensuring that any data collected through third-party services
                is protected. We rely on the security measures provided by these
                third-party services to safeguard your information.
              </span>
            </li>
            <li>
              Changes to This Privacy Policy
              <span className="mt-3 mb-3 d-block">
                We may update this Privacy Policy from time to time. Any changes
                will be posted on this page with an updated effective date. Your
                continued use of ToolWeaver after any changes indicates your
                acceptance of the new terms.
              </span>
            </li>
            <li>
              Contact Us
              <span className="mt-3 mb-3 d-block">
                If you have any questions or concerns about this Privacy Policy,
                please <Link to="/contact">contact us</Link>.
              </span>
            </li>
          </ol>
          <span className="d-block mt-4">
            By using ToolWeaver, you consent to the terms of this Privacy
            Policy. Thank you for visiting our site!
          </span>
        </Card>
      </Page>
    </>
  );
};

export default memo(PrivacyPolicyPage);
